module.exports = __webpack_public_path__ + "img/focus.027c6728.jpg";